/**
 * Created by felipe on 7/22/24.
 */
'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('quizzing', {
                parent: 'site',
                url: '/quizzing/:collectionType/:collectionId/:assetId/:isNewQuiz/:isFromPnP',
                params: {
                },
                data: {
                    roles: [],
                    pageTitle: 'quizzing.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/quizzing/templates/quizzing.html',
                        controller: 'QuizzingController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('quizzing');
                        return $translate.refresh();
                    }]
                }
            })
            .state('lmsEmbedQuizzing', {
                parent: 'site',
                url: '/lms/embed/quizzing/:collectionId/:assetId/:authToken',
                data: {
                    roles: [],
                    pageTitle: 'quizzing.title'
                },
                onEnter: [
                    '$state',
                    '$stateParams',
                    function ($state, $stateParams) {
                        // breadcrumb should be non-interactive version for media manager
                        sessionStorage.setItem('isAssignmentFromLMS', true);
                        $state.go('quizzing', {
                            collectionType: 'course',
                            collectionId: $stateParams.collectionId,
                            assetId: $stateParams.assetId,
                            isNewQuiz: false,
                            isFromPnP: true
                        });
                    }
                ]
            });
    });
